module.exports = __webpack_public_path__ + "static/fe97cdf54d24beda92175c39ea0dd58073804ad6baa9a484604870f2d95f8d8a-1763d5be1ef032d3f3d97dc06cf2d8b8.png";